export default __webpack_public_path__ + "static/banner-logistics-1d89f6ba81860c74cfd6e8248dcd5201.webp";